import axios from "axios";

// Your API Gateway endpoint
const API_BASE_URL = "https://tq8f7dzxgh.execute-api.ap-southeast-2.amazonaws.com/prod";

// Mock data for local development
// Set to true to use mock data, false to use real Lambda API
const FORCE_MOCK = false; // Change to true to force mock data for testing multi-page
const USE_MOCK = FORCE_MOCK && process.env.NODE_ENV === 'development' && window.location.hostname === 'localhost';

const MOCK_DATA = {
  keywordInfo: {
    keyword: "test-survey",
    form_id: "mock_form_001",
    merchant_id: "mock_merchant",
    pref_centre_id: "mock_pref_001",
    country_code: "AU",
    server: "prod",
    mobile_number: null // Set to "0412345678" to test prefill, or "HIDE_ME" to test hidden
  },
  form: {
    title: "Multi-Page Test Survey",
    submitText: "Complete Survey",
    formType: "go2survey.link",
    progressBarType: "dots", // Options: 'bar', 'steps', 'dots', 'percentage', 'none'
    progressBarColor: "#bfdd00",
    progressBarBgColor: "#e0e0e0",
    pages: [
      {
        id: 1,
        title: "Contact Information",
        fields: [
          { type: "text", name: "static_field_name", label: "Full Name", required: true, className: "form-control" },
          { type: "number", name: "static_field_mobile", label: "Mobile Number", required: true, className: "form-control" },
          { type: "text", name: "static_field_email", label: "Email Address", required: true, className: "form-control" }
        ]
      },
      {
        id: 2,
        title: "Your Preferences",
        fields: [
          { type: "select", name: "contact_preference", label: "Preferred Contact Method", className: "form-control",
            values: [{ label: "SMS", value: "sms" }, { label: "Email", value: "email" }, { label: "Phone", value: "phone" }] },
          { type: "radio-group", name: "frequency", label: "How often would you like to hear from us?",
            values: [{ label: "Weekly", value: "weekly" }, { label: "Monthly", value: "monthly" }, { label: "Quarterly", value: "quarterly" }] }
        ]
      },
      {
        id: 3,
        title: "Feedback",
        fields: [
          { type: "textarea", name: "comments", label: "Additional Comments", className: "form-control", rows: 4 },
          { type: "checkbox-group", name: "interests[]", label: "What interests you?",
            values: [{ label: "Product Updates", value: "products" }, { label: "Special Offers", value: "offers" }, { label: "Events", value: "events" }] }
        ]
      }
    ],
    formData: [], // Legacy fallback (empty for multi-page)
    colours: {
      title: "#022a1e",
      title_bg: "#FFF",
      background: "#f2f7f7",
      border: "#c2dedb",
      label: "#022a1e",
      font: "#3e3f3a",
      submit_bg: "#bfdd00",
      submit_font: "#022a1e"
    }
  }
};

export const fetchKeywordInfo = async (keyword) => {
  // Use mock data for local development
  if (USE_MOCK) {
    console.log("🧪 Using MOCK data for local development");
    return { ...MOCK_DATA, keywordInfo: { ...MOCK_DATA.keywordInfo, keyword } };
  }

  try {
    const response = await axios.post(`${API_BASE_URL}/prod-intouch-smartlinks-keywords`, {
      action: "getKeywordDetails",
      keyword: keyword.toLowerCase(),
    });

    return response.data; // { keywordInfo, form }
  } catch (error) {
    console.error("Error fetching keyword info:", error);
    return null;
  }
};
export const trackPageView = async (keyword) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/prod-intouch-smartlinks-keywords`, {
      action: "trackPageView",
      keyword: keyword.toLowerCase(),
      tracking_id: keyword

    });

    return response.data; // { keywordInfo, form }
  } catch (error) {
    console.error("Error fetching keyword info:", error);
    return null;
  }
};
